export const DemolitionB2NavOptions = [
  {
    label: 'Připojení na technickou infrastrukturu',
    target: 'b2.technicalInfrastructure',
  },
];
